var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 268,
    viewBox: "0 0 263 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_3437)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M126.56 230.276C191.456 230.276 244.065 180.912 244.065 120.019C244.065 59.1257 191.456 9.76196 126.56 9.76196C61.6636 9.76196 9.05481 59.1257 9.05481 120.019C9.05481 180.912 61.6636 230.276 126.56 230.276Z",
    fill: "url(#paint0_linear_41_3437)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.23 267.38C203.706 267.38 262.46 245.86 262.46 219.314C262.46 192.768 203.706 171.248 131.23 171.248C58.7537 171.248 0 192.768 0 219.314C0 245.86 58.7537 267.38 131.23 267.38Z",
    fill: "#FC88FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.23 250.934C184.634 250.934 227.926 235.076 227.926 215.515C227.926 195.953 184.634 180.095 131.23 180.095C77.8262 180.095 34.5338 195.953 34.5338 215.515C34.5338 235.076 77.8262 250.934 131.23 250.934Z",
    fill: "#FF4DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0954 225.006C80.129 225.006 86.6416 222.457 86.6416 219.314C86.6416 216.171 80.129 213.623 72.0954 213.623C64.0617 213.623 57.5492 216.171 57.5492 219.314C57.5492 222.457 64.0617 225.006 72.0954 225.006Z",
    fill: "#282020"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.774 225.006C190.807 225.006 197.32 222.457 197.32 219.314C197.32 216.171 190.807 213.623 182.774 213.623C174.74 213.623 168.227 216.171 168.227 219.314C168.227 222.457 174.74 225.006 182.774 225.006Z",
    fill: "#282020"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3483 207.931V216.779H82.2142V207.295L61.3483 207.931Z",
    fill: "#3F3232"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.521 207.931V216.779H172.655V207.295L193.521 207.931Z",
    fill: "#3F3232"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6569 193.385V207.931C55.6569 207.931 60.7127 211.095 72.1026 211.095C83.4924 211.095 87.9127 207.931 87.9127 207.931V196.548L55.6569 193.385Z",
    fill: "#307CF8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.212 193.385V207.931C199.212 207.931 194.149 211.095 182.766 211.095C171.384 211.095 166.956 207.931 166.956 207.931V196.548L199.212 193.385Z",
    fill: "#307CF8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0213 79.5435C55.0213 79.5435 51.2294 54.8785 57.5492 48.5516C63.869 42.2247 79.6862 37.7972 121.425 37.7972C163.164 37.7972 185.301 44.1242 186.565 46.6521C187.829 49.18 191.628 61.1983 190.357 91.5546C189.093 121.911 190.993 163.022 190.993 163.022L62.6121 159.23L49.9655 90.2978L55.0284 79.5435H55.0213Z",
    fill: "#0463FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1847 104.208C58.1847 104.208 69.5674 106.736 72.0954 111.799C74.6233 116.862 70.8314 125.081 70.8314 125.081L53.7573 120.019C53.7573 120.019 47.4304 102.944 58.1847 104.208Z",
    fill: "#342E6B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7654 135.829C22.7654 135.829 24.0294 111.164 41.1035 108.636C58.1776 106.108 62.605 108.636 67.668 113.699C72.7309 118.762 73.9949 137.1 73.9949 145.955C73.9949 154.809 76.5228 173.783 76.5228 173.783H176.447L181.503 149.754L182.766 122.561C182.766 122.561 186.558 109.279 205.532 109.279C224.506 109.279 231.461 125.724 228.297 142.163C225.134 158.601 205.532 159.237 202.368 158.609V194.656C202.368 194.656 174.54 202.247 123.946 202.247C73.3522 202.247 58.1705 198.455 53.1146 195.292V159.244C53.1146 159.244 24.0223 164.307 22.7583 135.843L22.7654 135.829Z",
    fill: "#004BC4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4287 144.212C81.4287 144.212 70.8386 151.01 69.5675 151.646C68.3035 152.281 66.404 154.809 67.0396 157.973C67.6751 161.136 67.0396 174.419 70.203 177.575C73.3665 180.738 91.7046 185.166 102.459 180.738C102.459 180.738 124.596 186.43 133.451 180.738C133.451 180.738 147.361 186.43 159.38 180.738C159.38 180.738 175.825 185.166 184.045 180.103C184.045 180.103 189.736 160.501 185.309 154.174L178.353 139.628L91.7117 138.992L81.4358 144.212H81.4287Z",
    fill: "#307CF8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.381 160.851C157.195 160.851 180.553 156.726 180.553 151.639C180.553 146.551 157.195 142.427 128.381 142.427C99.5668 142.427 76.2086 146.551 76.2086 151.639C76.2086 156.726 99.5668 160.851 128.381 160.851Z",
    fill: "#DE91E2"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M227.676 127.609L227.041 139.627C227.041 139.627 235.26 137.099 237.159 137.099C239.059 137.099 241.587 137.735 241.587 137.735L233.368 126.352L227.676 127.616V127.609Z",
    fill: "#FFC6C0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M225.148 138.364C225.148 138.364 234.003 135.2 235.267 134.572C236.531 133.936 239.059 133.308 239.059 133.308C239.059 133.308 251.706 138.999 254.241 142.791C256.768 146.583 249.178 145.954 249.178 145.954C249.178 145.954 231.468 146.59 226.412 143.427L225.148 138.364Z",
    fill: "#FBB6FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160.008 70.3743C160.008 71.9453 158.737 73.2235 157.159 73.2235C155.581 73.2235 154.31 71.9524 154.31 70.3743C154.31 68.7961 155.581 67.525 157.159 67.525C158.737 67.525 160.008 68.7961 160.008 70.3743Z",
    fill: "#307CF8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M160.008 96.303C160.008 97.874 158.737 99.1523 157.159 99.1523C155.581 99.1523 154.31 97.8812 154.31 96.303C154.31 94.7248 155.581 93.4537 157.159 93.4537C158.737 93.4537 160.008 94.7248 160.008 96.303Z",
    fill: "#307CF8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 98.5168C177.711 98.5168 199.212 71.9523 203.64 70.06C208.067 68.1605 212.494 70.2171 212.494 70.2171C212.494 70.2171 215.658 73.2234 218.186 79.5432C220.714 85.8701 230.832 116.226 233.367 120.654C235.895 125.081 238.43 129.509 238.43 129.509L228.312 134.572C228.312 134.572 211.238 106.743 208.71 101.052C206.182 95.3605 206.182 94.0965 206.182 94.0965C206.182 94.0965 196.698 114.334 194.163 118.762C191.636 123.189 181.517 135.207 176.454 137.1C171.391 138.999 177.718 98.524 177.718 98.524L177.711 98.5168Z",
    fill: "#1E1717"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M206.803 60.5695L213.758 59.3056C213.758 59.3056 219.45 52.9787 223.242 50.4508C227.033 47.9229 223.242 61.8335 221.978 64.3614C220.714 66.8893 216.915 68.1533 216.915 68.1533L206.796 67.5177V60.5624L206.803 60.5695Z",
    fill: "#FFC6C0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M219.457 52.9859C219.457 52.9859 221.356 58.0489 220.092 61.2052C218.828 64.3687 215.979 68.0034 215.979 68.0034C215.979 68.0034 219.457 70.6884 220.092 70.6884C220.728 70.6884 227.683 62.4692 229.576 54.2427C231.475 46.0235 230.211 43.4884 230.211 43.4884C230.211 43.4884 221.992 47.2803 219.457 52.9716V52.9859Z",
    fill: "#FBB6FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M211.694 134.366C212.459 131.139 210.463 127.903 207.235 127.138C204.008 126.373 200.771 128.37 200.007 131.597C199.242 134.825 201.238 138.061 204.466 138.826C207.693 139.59 210.93 137.594 211.694 134.366Z",
    fill: "#307CF8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M202.697 138.199C202.697 138.199 202.383 145.947 196.691 147.211C196.691 147.211 206.81 145.633 202.697 138.199Z",
    fill: "#307CF8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 126.974C206.646 126.974 208.067 120.018 213.13 118.119C213.13 118.119 203.325 118.119 206.646 126.974Z",
    fill: "#307CF8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M210.281 137.257C210.281 137.257 215.658 138.364 217.55 143.42C217.55 143.42 217.55 136.15 210.281 137.257Z",
    fill: "#307CF8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M211.866 66.8966C211.331 62.0551 208.967 59.5057 208.267 58.8559C207.989 58.8273 207.71 58.7702 207.424 58.6774C202.954 60.5697 161.265 61.8337 161.265 61.8337C161.265 61.8337 159.366 63.0976 158.102 71.3169C156.838 79.5362 156.838 108.629 156.838 108.629L149.882 111.792L154.945 141.513C154.945 141.513 160.008 147.204 173.919 143.412C187.83 139.62 185.937 130.766 185.302 118.747C184.666 106.729 175.818 78.2722 175.818 78.2722C175.818 78.2722 177.718 78.2722 182.145 75.1088C186.573 71.9453 211.238 70.0458 211.238 70.0458C211.238 70.0458 212.502 72.5737 211.873 66.8824L211.866 66.8966Z",
    fill: "#282020"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M109.407 80.8071C109.407 80.8071 110.671 81.4427 110.671 83.335C110.671 85.2274 108.772 93.4538 108.772 93.4538C108.772 93.4538 111.935 90.9259 113.835 91.5543C115.734 92.1899 117.626 92.8183 117.626 92.8183C117.626 92.8183 115.098 94.0822 114.463 94.0822C113.827 94.0822 114.463 95.9817 114.463 95.9817C114.463 95.9817 116.991 95.3462 118.255 97.8812C119.519 100.409 119.519 102.944 120.783 104.208C122.047 105.472 134.693 114.327 134.693 114.327L122.047 117.49C122.047 117.49 106.237 101.045 104.973 99.1523C103.709 97.2528 105.608 87.7696 106.237 85.8701C106.872 83.9706 108.764 80.8071 109.4 80.8071H109.407Z",
    fill: "#FFD3C7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7867 101.68C77.7867 101.68 75.8872 108.007 80.9502 109.271C80.9502 109.271 83.4781 108.007 84.742 108.636C86.006 109.271 71.4598 127.631 71.4598 119.39C71.4598 118.754 72.7238 114.963 69.5603 111.171C66.3969 107.379 66.3969 106.743 66.3969 106.743C66.3969 106.743 73.3522 100.416 77.7796 101.68H77.7867Z",
    fill: "#FFC6C0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5412 70.3743C88.5412 71.9453 87.2701 73.2235 85.6919 73.2235C84.1137 73.2235 82.8427 71.9524 82.8427 70.3743C82.8427 68.7961 84.1137 67.525 85.6919 67.525C87.2701 67.525 88.5412 68.7961 88.5412 70.3743Z",
    fill: "#307CF8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M129.016 70.3743C129.016 71.9453 127.745 73.2235 126.167 73.2235C124.589 73.2235 123.318 71.9524 123.318 70.3743C123.318 68.7961 124.589 67.525 126.167 67.525C127.745 67.525 129.016 68.7961 129.016 70.3743Z",
    fill: "#307CF8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5412 96.303C88.5412 97.874 87.2701 99.1523 85.6919 99.1523C84.1137 99.1523 82.8427 97.8812 82.8427 96.303C82.8427 94.7248 84.1137 93.4537 85.6919 93.4537C87.2701 93.4537 88.5412 94.7248 88.5412 96.303Z",
    fill: "#307CF8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M129.016 96.303C129.016 97.874 127.745 99.1523 126.167 99.1523C124.589 99.1523 123.318 97.8812 123.318 96.303C123.318 94.7248 124.589 93.4537 126.167 93.4537C127.745 93.4537 129.016 94.7248 129.016 96.303Z",
    fill: "#307CF8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1583 109.9C77.1583 109.9 82.2213 107.372 85.3776 106.736C88.5411 106.101 97.3959 99.7809 104.351 104.208C111.307 108.636 108.779 113.692 110.043 113.692C111.307 113.692 141.034 112.428 146.09 110.528C151.146 108.629 152.417 109.264 152.417 109.264C152.417 109.264 156.845 116.219 159.373 130.766C161.9 145.312 158.737 147.84 158.737 147.84H122.054C122.054 147.84 86.006 147.204 79.6791 139.621C73.3522 132.03 68.2964 122.546 69.5603 117.483C70.8243 112.42 77.1512 109.893 77.1512 109.893L77.1583 109.9Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M92.333 134.565C92.333 134.565 101.816 144.684 112.571 142.784C123.325 140.885 137.236 131.401 136.6 116.22C135.964 101.038 131.537 94.0826 131.537 94.0826C131.537 94.0826 132.801 85.8634 138.492 87.7557C144.184 89.6481 146.712 113.056 145.448 125.067C144.184 137.086 129.638 158.587 104.337 157.323C79.0365 156.059 78.4081 127.602 78.4081 127.602L92.3187 134.558L92.333 134.565Z",
    fill: "#FFD3C7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M108.143 90.298C108.143 90.298 110.671 89.034 111.935 89.6624C113.199 90.298 113.199 87.7629 115.098 89.0269C116.998 90.2908 117.626 90.9264 117.626 90.9264C117.626 90.9264 120.633 95.1967 117.548 97.1747C114.463 99.1528 108.143 95.9893 107.508 95.3538C106.872 94.7182 108.143 90.2908 108.143 90.2908V90.298Z",
    fill: "#FCB9B4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M103.716 69.4248V66.8969L112.571 60.5699L128.381 76.3801L124.589 87.1344L103.716 69.4248Z",
    fill: "#0843A4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M115.398 69.4244C115.048 70.0313 113.785 69.9528 112.578 69.253C111.371 68.5532 110.671 67.4963 111.021 66.8893C111.371 66.2823 112.635 66.3609 113.842 67.0607C115.048 67.7605 115.748 68.8174 115.398 69.4244Z",
    fill: "#5E5E5E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1283 138.607C54.2335 137.441 55.8055 133.979 54.6396 130.874C53.4737 127.769 50.0114 126.197 46.9062 127.363C43.8011 128.528 42.2291 131.991 43.395 135.096C44.5609 138.201 48.0232 139.773 51.1283 138.607Z",
    fill: "#307CF8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4751 120.019C40.4751 120.019 41.1106 126.346 45.5381 127.924C45.5381 127.924 37.9472 129.502 40.4751 120.019Z",
    fill: "#307CF8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5381 138.042C45.5381 138.042 38.5827 141.52 40.4751 147.847C40.4751 147.847 35.4193 137.093 45.5381 138.042Z",
    fill: "#307CF8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2295 137.728C51.2295 137.728 56.9209 142.791 55.6569 147.212C55.6569 147.212 57.5564 138.357 51.2295 137.728Z",
    fill: "#307CF8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M54.55 132.194C54.55 132.194 60.0843 133.301 62.6122 128.873C62.6122 128.873 57.2351 132.351 54.55 132.194Z",
    fill: "#307CF8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M135.343 94.7249L132.494 95.6747C132.494 95.6747 129.645 89.6691 125.224 90.2975C120.797 90.933 115.741 87.7696 115.741 85.8701C115.741 83.9706 122.068 85.8701 123.332 85.2345C124.596 84.599 122.696 76.3797 120.168 74.4802C117.641 72.5807 117.641 69.4172 118.905 69.4172C120.168 69.4172 122.696 71.3167 122.696 71.3167C122.696 71.3167 123.332 69.4172 125.86 71.3167L128.388 73.2162C128.388 73.2162 130.916 73.2162 132.18 75.1157C133.444 77.0153 139.771 85.4488 142.298 92.6112C144.826 99.7807 135.343 94.7178 135.343 94.7178V94.7249Z",
    fill: "#FFD3C7"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6122 73.8518C62.6122 73.8518 65.1401 72.5878 65.7756 73.8518C66.4112 75.1158 68.9391 78.2792 71.467 78.9148C73.9949 79.5503 78.4223 80.1787 80.9502 85.2417C83.4781 90.3046 86.6416 98.5239 79.0507 104.215C71.4599 109.907 67.668 111.171 59.4487 106.743C51.2294 102.316 46.1665 101.052 46.802 94.0965C47.4376 87.1412 52.4934 70.6955 62.6122 73.8589V73.8518Z",
    fill: "#FFD3C7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0213 102.944C55.0213 102.944 49.33 101.045 48.6944 106.108C48.0589 111.171 59.4488 110.535 61.3411 106.743C63.2335 102.951 55.0142 102.951 55.0142 102.951L55.0213 102.944Z",
    fill: "#FCB9B4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1218 73.8517C53.1218 73.8517 58.8132 75.7512 61.9767 75.1157C65.1401 74.4801 67.1396 76.0654 67.1396 76.0654C67.1396 76.0654 67.668 71.3238 61.3411 70.6883C55.0142 70.0527 53.1218 73.8517 53.1218 73.8517Z",
    fill: "#342E6B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0691 125.081C91.0691 125.081 96.132 135.2 99.2883 137.1C99.2883 137.1 92.333 147.854 88.534 151.646L87.8984 151.01C87.8984 151.01 73.9878 138.992 72.0883 128.873C70.1888 118.754 86.6345 118.119 91.0619 125.081H91.0691Z",
    fill: "#FCE3F6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0174 91.8828C69.3248 93.3467 67.9823 94.1679 66.3613 94.1036C65.9328 94.0894 65.9328 94.7535 66.3613 94.7749C68.1894 94.8463 69.8104 93.8823 70.5959 92.2256C70.7815 91.8399 70.2031 91.4972 70.0174 91.8899V91.8828Z",
    fill: "#CE5252"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.21
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2015 79.915C77.0584 81.0218 76.3086 83.0427 74.5162 84.4281C72.7238 85.8134 70.5887 86.0419 69.7246 84.9351C68.8605 83.8282 69.6175 81.8073 71.4099 80.422C73.2023 79.0366 75.3374 78.8081 76.2015 79.915Z",
    fill: "#FF7B7B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.21
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1261 90.9689C65.2329 91.8187 65.0187 93.9681 63.6405 95.7605C62.2623 97.5529 60.2485 98.317 59.1345 97.46C58.0277 96.6103 58.2419 94.4608 59.6201 92.6684C60.9983 90.8761 63.0121 90.112 64.1261 90.9689Z",
    fill: "#FF7B7B"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3747 78.6581C68.0821 78.6581 68.0821 80.6647 69.3747 80.6647C70.6672 80.6647 70.6672 78.6581 69.3747 78.6581Z",
    fill: "#231F20"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1414 88.7552C58.8489 88.7552 58.8489 90.7619 60.1414 90.7619C61.4339 90.7619 61.4339 88.7552 60.1414 88.7552Z",
    fill: "#231F20"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M67.618 76.0014C66.7325 76.5441 65.997 77.2725 65.4472 78.1508C64.9901 78.8792 66.1398 79.5505 66.604 78.8221C67.0325 78.1365 67.6037 77.5796 68.2964 77.1511C69.0319 76.7012 68.3607 75.5444 67.6252 75.9943L67.618 76.0014Z",
    fill: "#342E6B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6061 85.62C57.7206 86.1628 56.9851 86.8911 56.4352 87.7695C55.9782 88.4979 57.1279 89.1691 57.592 88.4407C58.0205 87.7552 58.5918 87.1982 59.2845 86.7697C60.02 86.3199 59.3487 85.163 58.6132 85.6129L58.6061 85.62Z",
    fill: "#342E6B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0844 75.1162C60.0844 75.1162 62.6123 89.6624 58.8204 99.1456C58.8204 99.1456 57.5565 89.0268 55.657 85.8634C55.657 85.8634 55.657 98.5101 53.7575 104.837C51.858 111.164 50.594 108 50.594 108L39.2113 123.182L31.6204 143.42L34.1483 155.438C34.1483 155.438 26.5574 152.91 25.929 151.011C25.929 151.011 28.4569 157.966 30.3564 159.865C30.3564 159.865 17.7097 152.275 18.3381 144.055C18.3381 144.055 17.7026 152.275 19.6021 154.81C19.6021 154.81 6.31986 143.427 12.0112 128.245C17.7026 113.063 32.8843 106.108 34.7767 100.417C36.6691 94.7253 39.2041 75.7517 51.2224 72.5883C58.8133 71.3243 60.0772 75.1162 60.0772 75.1162H60.0844Z",
    fill: "#262459"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M79.4006 83.735C78.0367 82.0712 75.6873 84.4491 77.037 86.0987C79.822 89.4907 80.9431 93.8396 80.179 98.1599C79.8005 100.259 83.0211 101.166 83.3996 99.0453C84.3993 93.4539 83.0068 88.1339 79.4006 83.735Z",
    fill: "url(#paint1_linear_41_3437)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M102.966 106.679C99.7097 103.066 94.8467 103.93 90.6835 105.172C88.6269 105.787 89.5052 109.007 91.569 108.393C94.5396 107.507 98.203 106.386 100.602 109.043C102.045 110.642 104.401 108.272 102.966 106.679Z",
    fill: "url(#paint2_linear_41_3437)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M61.3768 78.2079C60.7983 76.1442 57.5778 77.0225 58.1562 79.0934C59.6486 84.3992 59.3059 89.8192 57.0279 94.8536C56.1496 96.7959 59.0274 98.4955 59.9129 96.5388C62.5693 90.6689 63.1263 84.4277 61.3768 78.2079Z",
    fill: "url(#paint3_linear_41_3437)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M204.482 59.9414C192.114 65.5328 177.968 59.2487 165.171 63.2763C163.129 63.9189 164 67.1467 166.057 66.4968C179.196 62.3622 193.299 68.6391 206.16 62.8192C208.117 61.9338 206.417 59.0559 204.475 59.9343L204.482 59.9414Z",
    fill: "url(#paint4_linear_41_3437)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M154.217 109.628C153.967 108.721 153.046 108.264 152.16 108.464C150.732 108.785 149.382 109.271 148.047 109.864C147.226 110.235 147.026 111.428 147.447 112.149C147.94 112.999 148.904 113.12 149.732 112.749C150.796 112.27 151.91 111.935 153.046 111.685C153.924 111.485 154.445 110.471 154.21 109.628H154.217Z",
    fill: "url(#paint5_linear_41_3437)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M103.716 69.4246L72.9667 72.3309C72.9667 72.3309 66.3755 98.0956 85.6919 96.3032L110.521 75.1445L103.716 69.4246Z",
    fill: "url(#paint6_linear_41_3437)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M227.034 46.3163C224.62 47.6516 222.62 49.4797 220.992 51.6934C220.457 52.4218 220.878 53.5501 221.592 53.9786C222.435 54.4856 223.342 54.1 223.877 53.3787C225.163 51.6363 226.834 50.2438 228.719 49.2012C230.604 48.1658 228.919 45.2808 227.034 46.3163Z",
    fill: "url(#paint7_linear_41_3437)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M248.385 140.113C245.686 138.742 243.115 137.171 240.666 135.393C238.923 134.129 237.259 137.021 238.98 138.278C241.43 140.056 244.001 141.627 246.7 142.998C248.614 143.969 250.306 141.091 248.385 140.113Z",
    fill: "url(#paint8_linear_41_3437)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6509 19.7951C78.5437 20.4307 78.558 21.0662 78.5723 21.7089C78.5866 22.3373 78.6794 22.9586 78.8651 23.5727C79.265 24.9152 80.2933 25.7293 81.8143 26.1292C82.3499 26.2649 82.8998 26.3434 83.4568 26.3934C83.521 26.3934 83.5853 26.3934 83.6424 26.4148C83.8424 26.4791 83.8852 26.6433 83.7424 26.779C83.6281 26.8861 83.471 26.9361 83.3211 27.0004C82.4999 27.336 81.7643 27.7788 81.1002 28.3C80.2219 28.9856 79.7149 29.8639 79.3221 30.8065C79.1079 31.3207 78.9579 31.842 79.0151 32.3918C79.0365 32.5989 79.0222 32.806 78.9508 33.006C78.9365 33.0488 78.9365 33.0917 78.9151 33.1345C78.858 33.2559 78.7651 33.3487 78.608 33.3273C78.4723 33.3059 78.4081 33.1988 78.4081 33.0845C78.4081 32.8489 78.3795 32.5989 78.4295 32.3704C78.5152 31.9848 78.4938 31.6135 78.3938 31.2421C78.2081 30.5209 77.9796 29.8139 77.5583 29.1641C77.1513 28.5357 76.6228 28.0073 75.8802 27.6502C75.4089 27.4217 74.8947 27.3075 74.3591 27.2503C74.0449 27.2146 73.7307 27.1789 73.4094 27.1789C73.138 27.1789 73.0095 27.0861 73.0023 26.9575C72.9952 26.8076 73.1309 26.6505 73.3308 26.6076C73.8236 26.5005 74.252 26.2792 74.6162 25.9935C75.6445 25.1937 76.5657 24.3082 77.2155 23.2514C77.7011 22.4659 77.9582 21.6161 78.0296 20.7377C78.0582 20.3736 78.0796 20.0022 78.101 19.638C78.101 19.5309 78.1367 19.4238 78.1867 19.3238C78.2367 19.2239 78.3367 19.1739 78.4652 19.2024C78.5795 19.2239 78.6366 19.2953 78.6366 19.3881C78.6366 19.5309 78.6366 19.6666 78.6366 19.8094L78.6509 19.7951Z",
    fill: "#0843A4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 9.29782C158.316 9.93337 158.33 10.5689 158.344 11.2116C158.359 11.84 158.451 12.4613 158.637 13.0754C159.037 14.4179 160.065 15.232 161.586 15.6319C162.122 15.7676 162.672 15.8461 163.229 15.8961C163.293 15.8961 163.357 15.8961 163.414 15.9175C163.614 15.9818 163.657 16.146 163.514 16.2817C163.4 16.3888 163.243 16.4388 163.093 16.5031C162.272 16.8387 161.536 17.2814 160.872 17.8027C159.994 18.4883 159.487 19.3666 159.094 20.3092C158.88 20.8234 158.73 21.3447 158.787 21.8945C158.808 22.1016 158.794 22.3087 158.723 22.5086C158.708 22.5515 158.708 22.5943 158.687 22.6372C158.63 22.7586 158.537 22.8514 158.38 22.83C158.244 22.8086 158.18 22.7015 158.18 22.5872C158.18 22.3515 158.151 22.1016 158.201 21.8731C158.287 21.4875 158.266 21.1162 158.166 20.7448C157.98 20.0236 157.752 19.3166 157.33 18.6668C156.923 18.0384 156.395 17.51 155.652 17.1529C155.181 16.9244 154.667 16.8101 154.131 16.753C153.817 16.7173 153.503 16.6816 153.181 16.6816C152.91 16.6816 152.781 16.5888 152.774 16.4602C152.767 16.3103 152.903 16.1532 153.103 16.1103C153.596 16.0032 154.024 15.7818 154.388 15.4962C155.416 14.6964 156.338 13.8109 156.987 12.7541C157.473 11.9685 157.73 11.1188 157.802 10.2404C157.83 9.87624 157.852 9.50491 157.873 9.14072C157.873 9.0336 157.909 8.92649 157.959 8.82651C158.009 8.72654 158.109 8.67655 158.237 8.70511C158.351 8.72654 158.409 8.79795 158.416 8.89078C158.416 9.0336 158.416 9.16928 158.416 9.3121L158.423 9.29782Z",
    fill: "#0843A4"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M112.256 46.0165C112.185 46.4521 112.192 46.8948 112.199 47.3376C112.206 47.7732 112.278 48.2016 112.399 48.623C112.671 49.5513 113.385 50.1154 114.434 50.3868C114.806 50.4796 115.184 50.5367 115.57 50.5725C115.613 50.5725 115.663 50.5725 115.698 50.5867C115.834 50.6296 115.87 50.7438 115.77 50.8367C115.691 50.9152 115.584 50.9438 115.477 50.9866C114.913 51.2151 114.406 51.5222 113.942 51.8864C113.335 52.3577 112.985 52.9647 112.721 53.6145C112.578 53.9716 112.471 54.3286 112.506 54.7071C112.521 54.8499 112.506 54.9927 112.463 55.1284C112.456 55.157 112.456 55.1855 112.442 55.2141C112.406 55.2998 112.342 55.3641 112.228 55.3498C112.135 55.3355 112.085 55.2641 112.092 55.1784C112.092 55.0141 112.071 54.8428 112.106 54.6857C112.164 54.4214 112.149 54.1644 112.085 53.9073C111.956 53.4074 111.799 52.9218 111.507 52.472C111.228 52.0364 110.864 51.6722 110.35 51.4294C110.021 51.2723 109.671 51.1937 109.3 51.1509C109.086 51.1294 108.864 51.1009 108.643 51.1009C108.457 51.1009 108.372 51.0366 108.365 50.9509C108.365 50.8438 108.45 50.7438 108.593 50.7081C108.936 50.6367 109.229 50.4796 109.478 50.2868C110.193 49.737 110.821 49.13 111.271 48.3944C111.607 47.8517 111.778 47.2662 111.828 46.6592C111.849 46.4093 111.864 46.1522 111.878 45.9022C111.878 45.8237 111.899 45.7523 111.935 45.688C111.971 45.6166 112.035 45.588 112.128 45.6023C112.206 45.6166 112.242 45.6666 112.249 45.7309C112.249 45.8308 112.249 45.9237 112.249 46.0236L112.256 46.0165Z",
    fill: "#0843A4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M114.184 24.1082C112.806 24.1082 112.806 26.2505 114.184 26.2505C115.563 26.2505 115.563 24.1082 114.184 24.1082Z",
    fill: "#0843A4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6873 47.9662C74.3091 47.9662 74.3091 50.1085 75.6873 50.1085C77.0656 50.1085 77.0656 47.9662 75.6873 47.9662Z",
    fill: "#0843A4"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7617 72.4812C90.3835 72.4812 90.3835 74.6235 91.7617 74.6235C93.1399 74.6235 93.1399 72.4812 91.7617 72.4812Z",
    fill: "#0843A4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M161.029 38.5614C159.651 38.5614 159.651 40.7037 161.029 40.7037C162.407 40.7037 162.407 38.5614 161.029 38.5614Z",
    fill: "#0843A4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M181.31 27.8501C179.932 27.8501 179.932 29.9924 181.31 29.9924C182.688 29.9924 182.688 27.8501 181.31 27.8501Z",
    fill: "#0843A4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M109.807 18.9238C108.429 18.9238 108.429 21.0661 109.807 21.0661C111.185 21.0661 111.185 18.9238 109.807 18.9238Z",
    fill: "#0843A4"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4771 56.4141C84.7207 56.4141 84.7135 60.6987 87.4771 60.6987C90.2407 60.6987 90.2407 56.4141 87.4771 56.4141Z",
    fill: "#0843A4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M127.752 0.000244141C124.996 0.000244141 124.989 4.28484 127.752 4.28484C130.516 4.28484 130.516 0.000244141 127.752 0.000244141Z",
    fill: "#0843A4"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M166.742 43.5603C163.986 43.5603 163.979 47.8449 166.742 47.8449C169.506 47.8449 169.506 43.5603 166.742 43.5603Z",
    fill: "#0843A4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M176.311 11.783C173.555 11.783 173.547 16.0676 176.311 16.0676C179.075 16.0676 179.075 11.783 176.311 11.783Z",
    fill: "#0843A4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4112 10.7115C63.6548 10.7115 63.6476 14.9961 66.4112 14.9961C69.1747 14.9961 69.1747 10.7115 66.4112 10.7115Z",
    fill: "#0843A4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5495 19.9949C82.1713 19.9949 82.1713 22.1372 83.5495 22.1372C84.9277 22.1372 84.9277 19.9949 83.5495 19.9949Z",
    fill: "#0843A4"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3401 69.6248C63.9618 69.6248 63.9618 71.7671 65.3401 71.7671C66.7183 71.7671 66.7183 69.6248 65.3401 69.6248Z",
    fill: "#0843A4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_41_3437",
    x1: 126.56,
    y1: 230.276,
    x2: 126.56,
    y2: 9.76911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B88CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C19AFF",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_41_3437",
    x1: 76.6299,
    y1: 91.7115,
    x2: 83.7067,
    y2: 91.7115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FF7BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_41_3437",
    x1: 89.5124,
    y1: 106.836,
    x2: 103.416,
    y2: 106.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FF7BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_41_3437",
    x1: 56.8637,
    y1: 87.2198,
    x2: 62.3836,
    y2: 87.2198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FF7BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_41_3437",
    x1: 164.014,
    y1: 63.1763,
    x2: 207.032,
    y2: 63.1763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FF7BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_41_3437",
    x1: 147.24,
    y1: 110.678,
    x2: 154.274,
    y2: 110.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FF7BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_41_3437",
    x1: 71.8812,
    y1: 82.9067,
    x2: 110.528,
    y2: 82.9067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FF7BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_41_3437",
    x1: 220.749,
    y1: 50.1439,
    x2: 229.54,
    y2: 50.1439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FF7BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_41_3437",
    x1: 238.252,
    y1: 139.135,
    x2: 249.228,
    y2: 139.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FF7BAA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_3437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262.46,
    height: 267.38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.c7af3fbdf114465c5dc79029111ffe22.svg";
export { ForwardRef as ReactComponent };